export default __webpack_public_path__ + "static/media/feature-4.f2330501.jpg";